import { enumElementDrawStates, enumScrollBarButtonType, kScrollBarButtonSize } from "../constants";
import { QButton } from "./QButton";

export class QScrollBarButton extends QButton {
  constructor() {
    super();
    this.fButtonType = null;
    this.fParentPanel = null;
    this.fParentScrollBar = null;
  }

  InitScrollButton(parentScrollBar, parentPanel, targetPanel, buttonType) {
    this.SetHeight(kScrollBarButtonSize);
    this.SetWidth(kScrollBarButtonSize);
    this.fButtonType = buttonType;
    this.SetFillColor("#ECECEC");
    this.fParentPanel = parentPanel;
    this.fParentScrollBar = parentScrollBar;

    switch (buttonType) {
      case enumScrollBarButtonType.left:
        this.SetCmdCode("scrollLeft");
        parentScrollBar.fButton1 = this;
        break;
      case enumScrollBarButtonType.right:
        this.SetCmdCode("scrollRight");
        parentScrollBar.fButton2 = this;
        break;
      case enumScrollBarButtonType.up:
        this.SetCmdCode("scrollUp");
        parentScrollBar.fButton1 = this;
        break;
      case enumScrollBarButtonType.down:
        this.SetCmdCode("scrollDown");
        parentScrollBar.fButton2 = this;
        break;
    }
    parentPanel.PushElement(this);
    this.UpdateScrollButton();
  }

  UpdateScrollButton() {
    var parentPanel = this.fParentPanel;
    var parentScrollBar = this.fParentScrollBar;
    var buttonType = this.fButtonType;
    var theSlug = parentScrollBar.fSlug;

    switch (buttonType) {
      case enumScrollBarButtonType.left:
        this.SetPositionX(parentScrollBar.GetPositionX());
        this.SetPositionY(parentPanel.GetHeight() - this.GetHeight());
        this.SetEnabled(theSlug.GetPositionX() - kScrollBarButtonSize > 0);
        break;
      case enumScrollBarButtonType.right:
        this.SetPositionX(
          parentScrollBar.GetWidth() - this.GetWidth() + parentScrollBar.GetPositionX()
        );
        this.SetPositionY(parentPanel.GetHeight() - this.GetHeight());
        var slugRight = Math.ceil(theSlug.GetPositionX() + theSlug.fSlugSize);
        this.SetEnabled(slugRight < this.GetPositionX());
        break;
      case enumScrollBarButtonType.up:
        this.SetPositionX(parentScrollBar.GetPositionX());
        this.SetPositionY(parentScrollBar.GetPositionY());
        this.SetEnabled(theSlug.GetPositionY() - kScrollBarButtonSize > 0);
        break;
      case enumScrollBarButtonType.down:
        this.SetPositionX(parentPanel.GetWidth() - this.GetWidth());
        this.SetPositionY(
          parentScrollBar.GetHeight() - this.GetHeight() + parentScrollBar.GetPositionY()
        );
        var slugBottom = Math.ceil(theSlug.GetPositionY() + theSlug.fSlugSize);
        this.SetEnabled(slugBottom < this.GetPositionY());
        break;
    }
  }

  RenderScrollBarButton(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var thickness = 1;
    ctx.save();
    ctx.fillStyle = this.GetFillColor();
    ctx.fillRect(this.fHorzOffset, this.fVertOffset, this.fWidth, this.fHeight);
    var drawState = this.GetDrawState();
    switch (drawState) {
      case enumElementDrawStates.Hover:
        var gradient = ctx.createLinearGradient(
          this.fHorzOffset + thickness,
          this.fVertOffset + thickness,
          this.fHorzOffset - 2 * thickness,
          this.fHeight - 2 * thickness
        ); // this.fHeight
        gradient.addColorStop(0, "#FFECDA");
        gradient.addColorStop(1, "#FFDDB8");
        ctx.fillStyle = gradient;
        ctx.fillRect(
          this.fHorzOffset + thickness,
          this.fVertOffset + thickness,
          this.fWidth - 2 * thickness,
          this.fHeight - 2 * thickness
        );
        ctx.fillStyle = "#000000";
        break;
      case enumElementDrawStates.MouseDown:
        var gradient = ctx.createLinearGradient(
          this.fHorzOffset + thickness,
          this.fVertOffset + thickness,
          this.fHorzOffset - 2 * thickness,
          this.fHeight - 2 * thickness
        ); // this.fHeight
        gradient.addColorStop(0, "#FFDB9F");
        gradient.addColorStop(1, "#FFC533");
        ctx.fillStyle = gradient;
        ctx.fillRect(
          this.fHorzOffset + thickness,
          this.fVertOffset + thickness,
          this.fWidth - 2 * thickness,
          this.fHeight - 2 * thickness
        );
        ctx.fillStyle = "#000000";
        break;
      case enumElementDrawStates.Disabled:
        ctx.fillStyle = "#555555";
        break;
      case enumElementDrawStates.Std:
        ctx.fillStyle = "#000000";
        break;
    }

    var x0 = this.fHorzOffset;
    var y0 = this.fVertOffset;
    switch (this.fButtonType) {
      case enumScrollBarButtonType.left:
        var x1 = kScrollBarButtonSize * (5 / 8) + x0;
        var x2 = kScrollBarButtonSize * (3 / 8) + x0;
        var y1 = kScrollBarButtonSize * (3 / 4) + y0;
        var y2 = kScrollBarButtonSize * (1 / 4) + y0;
        var y3 = kScrollBarButtonSize * (1 / 2) + y0;
        break;
      case enumScrollBarButtonType.right:
        var x1 = kScrollBarButtonSize * (3 / 8) + x0;
        var x2 = kScrollBarButtonSize * (5 / 8) + x0;
        var y1 = kScrollBarButtonSize * (3 / 4) + y0;
        var y2 = kScrollBarButtonSize * (1 / 4) + y0;
        var y3 = kScrollBarButtonSize * (1 / 2) + y0;
        break;
      case enumScrollBarButtonType.up:
        var x1 = kScrollBarButtonSize * (1 / 4) + x0;
        var x2 = kScrollBarButtonSize * (3 / 4) + x0;
        var x3 = kScrollBarButtonSize * (1 / 2) + x0;
        var y1 = kScrollBarButtonSize * (5 / 8) + y0;
        var y2 = kScrollBarButtonSize * (3 / 8) + y0;
        break;
      case enumScrollBarButtonType.down:
        var x1 = kScrollBarButtonSize * (1 / 4) + x0;
        var x2 = kScrollBarButtonSize * (3 / 4) + x0;
        var x3 = kScrollBarButtonSize * (1 / 2) + x0;
        var y1 = kScrollBarButtonSize * (3 / 8) + y0;
        var y2 = kScrollBarButtonSize * (5 / 8) + y0;
        break;
    }

    if (
      this.fButtonType === enumScrollBarButtonType.up ||
      this.fButtonType === enumScrollBarButtonType.down
    ) {
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y1);
      ctx.lineTo(x3, y2);
      ctx.lineTo(x1, y1);
      ctx.closePath();
      ctx.stroke();
      ctx.fill();
    } else {
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x1, y2);
      ctx.lineTo(x2, y3);
      ctx.lineTo(x1, y1);
      ctx.closePath();
      ctx.stroke();
      ctx.fill();
    }

    ctx.restore();
  }

  DoRenderElement(drawBuffer) {
    //this.RenderScrollBarButton(drawBuffer);
  }
}
